import React from 'react'

function About() {
  return (
    <section className='section'>
        <h2>About</h2>
        <p className='home-paragraph'>
          Have little to no savings? Don't like thinking about it? Not sure you can ever save up for anything 'big'?
        </p>
        <p className='home-paragraph'>
          Rainy days happen all the time, save up for the things you will need.
          Whether that is an emergency fund for those unforeseeable situations - like a car break down or redundancy. Or
          you would like to buy your first property, these calculators should give you a realistic breakdown of what monthly amount 
          you can put aside and how that can become a significant sum over time. 
        </p>
        <p className='home-paragraph'>
          The earlier you start saving regularly, even 20 a month, the more you will thank yourself in the future!
          These tools will help you realise that if you save a little, consistently, 
          you will be able to save up a considerable amount. If you haven't thought about your personal 
          finances, here is a good place to start. 
        </p>
        <p className='home-paragraph'>
          Play around with the simulators to help you understand what you are capable of achieving in savings. 
          Have a look at how interest rates can have an effect on the final goal over time. Although interest rates are actually
          really low at the moment, you may find some saving accounts are better than others and its worth shopping around. 
          Interest rates are currently changing at the moment and there is a lot of talk about inflation increasing. 
          If you are unsure about what that means, its worth looking at the inflation calculator.
        </p>
        <h3>Why?</h3>
        <p className='home-paragraph'>
            I have been making little calculators like the ones you can find on this website
            as a hobby. But why!? Well, there is a lot of talk around inflation at the moment, 
            and the conversations can get political, I think the result is that a lot of people 
            disengage from that conversation.
        </p>
        <p className='home-paragraph'>
            While it's tempting to think we might get lucky one day and make a pot of money, some people are opting for high risk 
            investments. That is a personal choice but shouldn't come at the cost of traditional saving methods. 
        </p>
        <p className='home-paragraph'>
            This website is not about giving advice as much as it is about demonstrating
            that classic saving strategies are important, <em>especially</em> for those who haven't started yet. 
        </p>
        <p className='home-paragraph'> 
            So if people, especially (but not only) the young, are getting themselves thinking about and organising 
            their personal finances, I am certain that they will be thanking themselves in the future. 
        </p>
    </section>
  )
}

export default About